// @flow
import {
  CANDIDATE_CREATE_REQUEST,
  CANDIDATE_CREATE_FAIL,
  CANDIDATE_CREATE_SUCCESS,
  CANDIDATE_CREATE_RESET,
  PATIENT_SECOND_OPINION_CREATE_REQUEST,
  PATIENT_SECOND_OPINION_UPDATE_REQUEST,
  PATIENT_SECOND_OPINION_BOOKING_REQUEST,
  BOOKING_UPDATE_REQUESTED,
  MODAL_CANDIDATE_CREATE_SUCCESS,
  BOOKING_CREATE_SUCCESS,
  BOOKING_UPDATE_SUCCESS
} from './constants';

import type { CandidateCreateData, CandidateCreateResponse } from './types';

export const createCandidate = (data: CandidateCreateData) => ({
  type: CANDIDATE_CREATE_REQUEST,
  data
});

export const createSecondOpinionPatient = (data: CandidateCreateData) => ({
  type: PATIENT_SECOND_OPINION_CREATE_REQUEST,
  data
});
export const updateSecondOpinionPatient = (data: CandidateCreateData) => ({
  type: PATIENT_SECOND_OPINION_UPDATE_REQUEST,
  data
});

export const requestBookingDetails = (slug: string) => ({
  type: PATIENT_SECOND_OPINION_BOOKING_REQUEST,
  slug
});

export const failCandidateCreate = (error: Error) => ({
  type: CANDIDATE_CREATE_FAIL,
  error
});

export const successCandidateCreate = (data: CandidateCreateResponse) => ({
  type: CANDIDATE_CREATE_SUCCESS,
  data
});

export const successBookingCreate = (data: CandidateCreateResponse) => ({
  type: BOOKING_CREATE_SUCCESS,
  data
});

export const successBookingUpdate = (data: CandidateCreateResponse) => ({
  type: BOOKING_UPDATE_SUCCESS,
  data
});

export const updateBookingDetails = (data: CandidateCreateResponse) => ({
  type: BOOKING_UPDATE_REQUESTED,
  data
});

export const successModalCandidateCreate = (data: CandidateCreateResponse) => ({
  type: MODAL_CANDIDATE_CREATE_SUCCESS,
  data
});

export const resetCandidateCreate = (isModal: boolean) => ({
  type: CANDIDATE_CREATE_RESET,
  isModal
});
